import _export from '../internals/export.js';
import numberParseInt from '../internals/number-parse-int.js';

var $ = _export;
var parseInt = numberParseInt; // `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing

$({
  target: 'Number',
  stat: true,
  forced: Number.parseInt != parseInt
}, {
  parseInt: parseInt
});
